import { render, staticRenderFns } from "./ECNInnovativePracticeCustom.vue?vue&type=template&id=52e68cc5&scoped=true"
import script from "./ECNInnovativePracticeCustom.vue?vue&type=script&lang=js"
export * from "./ECNInnovativePracticeCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e68cc5",
  null
  
)

export default component.exports